<template>
  <div class="app-chrome-container">
    <div v-if="!isLoading">
      <NavBar />
      <div class="app-chrome">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NavBar from '@/components/elements/NavBar.vue';

export default {
  components: {
    NavBar,
  },
  computed: {
    ...mapGetters(['isLoading']),
  },
};
</script>
